import Vue from "vue";
import "./plugins/axios";
import "./plugins/vueEllipsis";
import "./plugins/vueMarqueeTextComponent";
import "./plugins/vueTimeago";
import Axios from "axios";
import router from "./router";
import store from "./store/index";
import vuetifyObj from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import App from "./App.vue";
import "./plugins/vueMeta";
(async () => {
  // import './src/sass/main.scss'
  Vue.config.productionTip = false;
  let res = await Axios.get("/config.json");
  let config = res.data;
  config.apiEndPoint =
    config.net && config.net === "testnet"
      ? config.apiTestnetEndPoint
      : config.apiMainnetEndPoint;
  config.themeMutation =
    config.themeMutation && typeof config.themeMutation === "boolean"
      ? config.themeMutation
      : false;
  const themes = ["red", "yellow", "purple", "blue", "cyan"];
  if (!(config.theme && themes.includes(config.theme))) {
    config.theme = "cyan";
  }
  const versions = ["pro", "basic"];
  if (!(config.version && versions.includes(config.version))) {
    config.version = "pro";
  }
  Vue.prototype.$config = config;
  store.commit("updateTheme", config.theme);
  const vuetify = vuetifyObj(config);
  config.primaryColor = vuetify.preset.theme.themes.light.primary;
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
})();
